<template>
  <div
    class="fixed w-full h-full flex justify-center items-center bg-grays-900 bg-opacity-50 bg-overlay z-50 top-0 left-0"
  >
    <div
      class="relative flex flex-col w-9/12 h-fit rounded bg-white overflow-hidden mr-[190px]"
    >
      <!-- intro -->
      <div class="relative flex flex-row justify-start p-[54px] bg-primary-700">
        <!-- close btn -->
        <button
          class="absolute left-[25px] top-[27px] w-9 h-9 rounded flex justify-center items-center text-white"
          @click="closeRegistrationModal"
        >
          <span class="material-symbols-rounded">close</span>
        </button>
        <!-- sale title -->
        <div class="flex flex-row gap-[20px] items-center">
          <div
            class="flex justify-center items-center h-[40px] w-[40px] bg-complementary-600 text-complementary-900 rounded-full"
          >
            <span class="material-symbols-rounded">account_circle</span>
          </div>
          <div class="flex flex-col">
            <h1 v-if="step === 1" class="text-white text-2xl font-medium">
              בואו נשלים את ההרשמה שלכם
            </h1>
            <h1 v-if="step === 2" class="text-white text-2xl font-medium">
              מוסיפים פרטים לתשלום
            </h1>
            <h1 v-if="step === 3" class="text-white text-2xl font-medium">
              מתחילים להזמין!
            </h1>
            <p class="text-purple_semantic text-base font-regular">
              פרופיל: שלב {{ step }} מתוך 3
            </p>
          </div>
        </div>
      </div>
      <!-- content -->
      <div class="flex flex-col justify-center items-center h-[30rem]">
        <complete-registration-page1
          v-if="step === 1"
          ref="completeRegistrationPage1"
        />
        <complete-registration-page2
          v-if="step === 2"
          ref="completeRegistrationPage2"
        />
        <complete-registration-page3
          v-if="step === 3"
          ref="completeRegistrationPage3"
        />
      </div>

      <!-- action -->
      <div
        class="flex flex-row justify-end gap-[12px] pt-[52px] pb-[32px] pl-[43px] border-t border-grays-400"
      >
        <button-text v-if="step > 1" @click="handleBackStep"
          >לחזור אחורה
        </button-text>
        <button-primary v-if="step < 3" @click="handleNextStep">
          {{ isLoading ? "טוען נתונים..." : "ממשיכים" }}
        </button-primary>
        <div v-if="step === 3" class="flex flex-row gap-[32px]">
          <div class="flex items-center">
            <check-box v-model="checked"></check-box>
            בסדר, מאשרים.
          </div>
          <button-primary :disabled="!checked" @click="handleStartOrder"
            >מתחילים בקניה
          </button-primary>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import InputDefault from "@/components/Global/InputDefault.vue";
import TooltipCvv from "@/components/Global/TooltipCVV.vue";
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";
import ButtonText from "@/components/Global/ButtonText.vue";
import CompleteRegistrationPage1 from "@/components/CompleteRegistrationModal/CompleteRegistrationModalPage1.vue";
import CompleteRegistrationPage2 from "@/components/CompleteRegistrationModal/CompleteRegistrationModalPage2.vue";
import CompleteRegistrationPage3 from "@/components/CompleteRegistrationModal/CompleteRegistrationModalPage3.vue";
import CheckBox from "@/components/Global/CheckBox.vue";
import axiosInstance from "@/helpers/axios";

export default {
  name: "complete-registration-modal",
  components: {
    CheckBox,
    CompleteRegistrationPage3,
    CompleteRegistrationPage2,
    CompleteRegistrationPage1,
    ButtonText,
    ButtonSecondary,
    ButtonPrimary,
    TooltipCvv,
    InputDefault,
  },
  data() {
    return {
      step: 1,
      isLoading: false,
      checked: false,
      cardData: {
        type: Object,
      },
    };
  },
  props: ["closeModal"],
  computed: {
    ...mapGetters({
      lname: "user/getLname",
      fname: "user/getFname",
      city: "user/getCity",
      street: "user/getStreet",
      allPhoneNumbers: "user/getAllPhoneNumbers",
      cardNumber: "card/getCardNumber",
      cvv: "card/getCvv",
      expirationDate: "card/getExpirationDate",
      idNumber: "card/getIdNumber",
    }),
  },
  methods: {
    ...mapMutations({
      toggleShowModal: "order/toggleShowModal",
    }),
    closeRegistrationModal() {
      this.toggleShowModal();
    },
    async handleStartOrder() {
      const formData = {
        save_tokef: this.expirationDate,
        save_taz: this.idNumber,
        save_card: this.cardNumber.replace(/\s/g, ""),
        save_cvv: this.cvv,
        is_default: true,
      };
      try {
        await axiosInstance.post("/payment_methods/credit_card", formData);
      } catch (e) {
        console.error(e);
      }
      const dataForm = {
        tzl: this.idNumber,
        fname: this.fname,
        lname: this.lname,
        street: this.street,
        city: this.city,
      };
      try {
        await axiosInstance.put("/clients", dataForm);
        this.toggleShowModal();
      } catch (error) {
        console.error(error);
      }
    },
    handleBackStep() {
      this.step--;
    },
    async handleNextStep() {
      if (this.step === 1) {
        const isValid = this.$refs.completeRegistrationPage1.validateForm();
        if (isValid) {
          this.step++;
        }
      } else if (this.step === 2) {
        const isValid = this.$refs.completeRegistrationPage2.validateForm();
        if (isValid) {
          this.step++;
        }
      }
    },
  },
};
</script>

<style>
</style>